(function () {
  'use strict';

  // --- Patch: Stamped badges ---
  // .stamped-badge uses aria-label but is a bare <span> with no role,
  // making the label invalid. Adding role="img" fixes this.
  function patchStampedBadges(root) {
    // Check root itself (when the badge span is the directly added node)
    if (root.matches && root.matches('.stamped-badge:not([role])')) {
      root.setAttribute('role', 'img');
    }
    root.querySelectorAll('.stamped-badge:not([role])').forEach(function (el) {
      el.setAttribute('role', 'img');
    });
  }

  // --- Patch: LB-Upsell PPA checkboxes and compare-at prices ---
  // Checkboxes have no label. Derive label from sibling product title.
  // Compare-at prices have no semantic meaning for screen readers.
  function patchPPAUpsell(root) {
    var containers = root.matches && root.matches('.ppa-prod-container')
      ? [root]
      : Array.from(root.querySelectorAll('.ppa-prod-container'));
    containers.forEach(function (container) {
      var checkbox = container.querySelector('.ppa-prod-checkbox-left:not([aria-label])');
      var title = container.querySelector('.ppa-prod-details-title');
      if (checkbox && title) {
        checkbox.setAttribute('aria-label', 'Add ' + title.textContent.trim() + ' to order');
      }

      var comparePrice = container.querySelector('.lb-upsell-compare-at-price:not([aria-label])');
      if (comparePrice) {
        var priceText = comparePrice.textContent.trim();
        if (priceText) {
          comparePrice.setAttribute('aria-label', 'Regular price ' + priceText);
          // Hide the inner money span so screen readers use the outer aria-label only
          var innerSpan = comparePrice.querySelector('.lb-upsell-money-2');
          if (innerSpan) innerSpan.setAttribute('aria-hidden', 'true');
        }
      }
    });
  }

  function applyPatches(root) {
    patchStampedBadges(root);
    patchPPAUpsell(root);
  }

  // Run immediately for anything already in the DOM
  applyPatches(document);

  // Watch for async-injected content (Stamped, LB-Upsell load after page)
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1) {
          applyPatches(node);
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

})();
